function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
});

var SvgIconInsightKronos = function SvgIconInsightKronos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480.003 480.003",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,480.0019989013673,480.00354003906244)"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140.935,369.074c3.335,4.073,6.919,7.937,10.731,11.569h0.024c23.716,22.776,55.35,35.454,88.232,35.36     c2.088,0,4.192-0.048,6.296-0.152c67.558-4.017,120.628-59.38,121.784-127.048c0.328-38.926-17.176-75.862-47.512-100.256     c-5.491-4.65-8.607-11.518-8.488-18.712v-17.832c-0.042-10.134-6.445-19.15-16-22.528v-9.472c-0.021-5.923-2.245-11.627-6.24-16     c8.32-9.044,8.32-22.956,0-32c8.87-9.677,8.215-24.712-1.461-33.581c-2.566-2.352-5.618-4.112-8.939-5.155     c-3.652-21.716-24.216-36.36-45.932-32.708c-16.759,2.818-29.89,15.949-32.708,32.708c-12.534,3.899-19.535,17.22-15.636,29.755     c1.038,3.336,2.798,6.403,5.156,8.981c-8.32,9.044-8.32,22.956,0,32c-3.995,4.373-6.219,10.077-6.24,16v9.472     c-9.555,3.378-15.958,12.394-16,22.528v18.76c-0.142,7.161-3.497,13.879-9.136,18.296     C104.204,233.817,96.176,314.413,140.935,369.074z M240.001,16.003c10.168,0.012,19.229,6.418,22.632,16h-45.264     C220.772,22.421,229.833,16.015,240.001,16.003z M208.001,48.003h64c4.418,0,8,3.582,8,8s-3.582,8-8,8h-64c-4.418,0-8-3.582-8-8     S203.583,48.003,208.001,48.003z M208.001,80.003h64c4.418,0,8,3.582,8,8s-3.582,8-8,8h-64c-4.418,0-8-3.582-8-8     S203.583,80.003,208.001,80.003z M200.001,120.003c0-4.418,3.582-8,8-8h64c4.418,0,8,3.582,8,8v8h-80V120.003z M169.001,201.483     v-0.04c9.36-7.45,14.869-18.718,15-30.68v-18.76c0-4.418,3.582-8,8-8h96c4.418,0,8,3.582,8,8v17.832     c-0.17,12.028,5.127,23.483,14.4,31.144c26.553,21.332,41.88,53.645,41.6,87.704c-0.987,59.218-47.422,107.682-106.544,111.2     c-61.76,3.017-114.272-44.604-117.289-106.364C126.439,258.105,141.585,223.965,169.001,201.483z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.001,432.003c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8s8-3.582,8-8v-32     C248.001,435.584,244.42,432.003,240.001,432.003z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.01,412.712c-0.003-0.002-0.006-0.004-0.009-0.005c-3.827-2.207-8.72-0.894-10.927,2.934     c0,0.001-0.001,0.002-0.001,0.002l-16,27.704c-2.234,3.812-0.956,8.713,2.856,10.947c3.812,2.234,8.713,0.956,10.947-2.856     c0.018-0.03,0.035-0.061,0.053-0.092l16-27.704C173.142,419.818,171.835,414.924,168.01,412.712z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.455,357.021c-0.031,0.018-0.062,0.036-0.093,0.054l-27.704,16c-3.841,2.183-5.185,7.067-3.002,10.908     c2.183,3.841,7.067,5.185,10.908,3.002c0.031-0.018,0.062-0.036,0.093-0.054l27.704-16c3.841-2.183,5.185-7.067,3.002-10.908     C113.18,356.181,108.296,354.837,104.455,357.021z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.001,288.003c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32     C92.42,296.003,96.001,292.421,96.001,288.003z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.566,202.878c0.03,0.018,0.061,0.035,0.092,0.053l27.704,16c3.812,2.234,8.713,0.956,10.947-2.856     c2.234-3.812,0.956-8.713-2.856-10.947c-0.03-0.018-0.061-0.035-0.092-0.053l-27.704-16c-3.812-2.234-8.713-0.956-10.947,2.856     C71.476,195.742,72.754,200.643,76.566,202.878z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.649,220.003c1.404,0,2.784-0.37,4-1.072l27.704-16c3.841-2.184,5.184-7.068,3-10.909s-7.068-5.184-10.909-3     c-0.031,0.017-0.061,0.035-0.092,0.053l-27.704,16c-3.826,2.209-5.137,7.102-2.928,10.928     C366.151,218.478,368.791,220.003,371.649,220.003z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.001,280.003h-32c-4.418,0-8,3.582-8,8s3.582,8,8,8h32c4.418,0,8-3.582,8-8S428.42,280.003,424.001,280.003z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.439,373.128c-0.031-0.018-0.062-0.036-0.093-0.054l-27.704-16c-3.811-2.235-8.713-0.957-10.948,2.854     c-2.235,3.811-0.957,8.713,2.854,10.948c0.031,0.018,0.062,0.036,0.093,0.054l27.704,16c3.811,2.235,8.713,0.957,10.948-2.854     C408.528,380.265,407.25,375.363,403.439,373.128z",
    fill: "currentColor",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.929,443.347l-16-27.704c-2.183-3.841-7.067-5.185-10.908-3.002c-3.841,2.183-5.185,7.067-3.002,10.908     c0.018,0.031,0.036,0.062,0.054,0.093l16,27.704c2.183,3.841,7.067,5.185,10.908,3.002c3.841-2.183,5.185-7.067,3.002-10.908     C338.965,443.409,338.947,443.378,338.929,443.347z",
    fill: "currentColor",
    style: {}
  })))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInsightKronos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconInsightKronos.ba9b9d02.svg";
export { ForwardRef as ReactComponent };